import { Component } from "@angular/core";
import { DialogRef } from "../../../core/ui/dialog/dialog-ref";
import { NavigatorService } from "../../../core/navigation/navigator.service";
import { SessionService } from "../../../core/state/session.service";
import { OrganizationService } from "../../../features/shared/organization/organization.service";
import { UIService } from "../../../core/ui/ui.service";

@Component({
    selector: "upgrade-nag",
    templateUrl: "upgrade-nag-dialog.component.html",
    styleUrls: ["upgrade-nag-dialog.component.scss"],
})
export class ElementsBillingNagDialogComponent {
    user: any;
    issue: any;

    constructor(
        private dialogRef: DialogRef<ElementsBillingNagDialogComponent>,
        private navigator: NavigatorService,
        private session: SessionService,
        private orgService: OrganizationService,
        private ui: UIService,
    ) {
        this.user = session.getUser();
        this.issue = dialogRef.params.issue;
    }

    close(): void {
        this.dialogRef.close();
    }

    upgrade(): void {
        this.dialogRef.close();
        this.navigator.go(["/org", "billing"]);
    }

    notify(): void {
        this.orgService
            .billingNotifyQuota({
                type: "quota",
                target: {
                    name: this.issue.key,
                    url: location.href,
                },
            })
            .subscribe(() => {
                this.ui.toast({
                    type: "success",
                    title: $localize`Admin notified`,
                    message: $localize`We've sent notification to administrator of your organization.`,
                });
            });
    }
}
